import React, { useEffect, useState } from 'react';
import { Footer } from "@wfp/ui";
import { ConfigApp } from "../../controllers/ConfigApp";
import {encode as base64_encode} from 'base-64';

// Footer component
export const FooterHome = () => {
    const [list, setList] = useState([]);
    let ran = false;
    useEffect(() => {
        if (ran) return;
            ConfigApp("/appConfig").then((e)=>{
                setList(e)
            
            })
            .catch((e)=>{
                console.warn(e);
                document.getElementById('invalidMessage').classList.remove('hide');
                
            });
           
        return () => (ran = true);
    }, [])

    const disCourse = ()=>{
        if(list && list.length>0){
            const entries = Object.values(list);
            return entries.map((a) => {
                if(a.name_key.includes("edufami_sponsor")){
                    return (<div className="ft-split" key={a.name_key}> 
                        <img className="img-sponsor img-sponsoro" src = {(a.image_type==='svg')?`data:image/svg+xml;base64,${base64_encode(a.image_value)}`:`data:image/${a.image_type}+xml;base64,${btoa(a.image_value)}`} alt="Sponsor"/>
                    </div>)
                }
                
            })
        }
        
    }

    return (
        <div className="footer-section footer-section-home">
        <Footer
        logo={<div className='foot-cont'>
            {disCourse()}
        </div>}
        logoExtended={<div></div>}
        >
            &nbsp;
        </Footer>
        </div>
    )
}
